import { gql, useMutation, useQuery } from '@apollo/client'

export const STUDENT_INSIGHT = gql`
  query StudentInsight($id: ID!) {
    student(id: $id) {
      id
      insights {
        status
        reason
        needsAttention
        firstLessonAt
        lastLessonAt
        nextLessonAt
        completedCount
        canceledCount
        typicalCadenceDays
        lifetimeValueInCents
        averageBookingValueInCents
      }
    }
  }
`

export const STUDENT_INSIGHTS_SUMMARY = gql`
  query StudentInsightsSummary($limit: Int) {
    studentInsightsSummary {
      needsAttentionCount
      needsAttention(limit: $limit) {
        status
        reason
        lastLessonAt
        student {
          id
          firstName
          lastName
          contact {
            externalId
          }
        }
      }
    }
  }
`

export const CHAT_FOLLOW_UP_CONTEXT = gql`
  query ChatFollowUpContext($contactExternalId: ID!) {
    studentInsightsSummary {
      forContact(contactExternalId: $contactExternalId) {
        status
        reason
        needsAttention
        followUpDraft
        followUpContext {
          kind
          label
          value
        }
        student {
          id
          firstName
        }
      }
    }
  }
`

export const SNOOZE_STUDENT_INSIGHT = gql`
  mutation SnoozeStudentInsight($studentId: ID!, $days: Int) {
    snoozeStudentInsight(studentId: $studentId, days: $days) {
      success
      message
    }
  }
`

export const DISMISS_STUDENT_INSIGHT = gql`
  mutation DismissStudentInsight($studentId: ID!) {
    dismissStudentInsight(studentId: $studentId) {
      success
      message
    }
  }
`

export function useStudentInsight(studentId) {
  return useQuery(STUDENT_INSIGHT, {
    variables: { id: studentId },
    skip: !studentId,
    fetchPolicy: 'cache-and-network',
  })
}

export function useStudentInsightsSummary(limit) {
  return useQuery(STUDENT_INSIGHTS_SUMMARY, {
    variables: { limit },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })
}

export function useChatFollowUpContext(contactExternalId) {
  return useQuery(CHAT_FOLLOW_UP_CONTEXT, {
    variables: { contactExternalId },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })
}

export function useSnoozeStudentInsight() {
  return useMutation(SNOOZE_STUDENT_INSIGHT)
}

export function useDismissStudentInsight() {
  return useMutation(DISMISS_STUDENT_INSIGHT)
}
